// Berries-n-Cream — base.js

// Mobile nav toggle
document.addEventListener('DOMContentLoaded', function () {

  const navToggle = document.querySelector('.bnc-nav__toggle');
  const navDrawer = document.querySelector('.bnc-nav__drawer');
  const navClose  = document.querySelector('.bnc-nav__close');

  if (navToggle && navDrawer) {
    navToggle.addEventListener('click', function () {
      navDrawer.classList.toggle('is-open');
      document.body.classList.toggle('nav-open');
      navToggle.setAttribute('aria-expanded',
        navDrawer.classList.contains('is-open') ? 'true' : 'false'
      );
    });
  }

  if (navClose && navDrawer) {
    navClose.addEventListener('click', function () {
      navDrawer.classList.remove('is-open');
      document.body.classList.remove('nav-open');
    });
  }

  // Close nav on outside click
  document.addEventListener('click', function (e) {
    if (navDrawer && navDrawer.classList.contains('is-open')) {
      if (!navDrawer.contains(e.target) && !navToggle.contains(e.target)) {
        navDrawer.classList.remove('is-open');
        document.body.classList.remove('nav-open');
      }
    }
  });

  // Announcement bar dismiss
  const annDismiss = document.querySelector('.bnc-announcement__close');
  const annBar     = document.querySelector('.bnc-announcement');
  if (annDismiss && annBar) {
    annDismiss.addEventListener('click', function () {
      annBar.style.display = 'none';
    });
  }

});
